import React, { Component } from 'react';
import PersonalData from '../../Components/Tabs/PersonalData';
import { getTranslation } from '../../Utilities/GetTranslation.js';

class Personal extends Component {
    constructor(props) {
        super(props);
        
        this.state = {};

        this.save = this.save.bind(this);
    }
    
    async save() {
        var ok = await this.refs.activeComponent.isValidated();
        
        this.setState({
            successMessage: ok
        });

        if (ok) {
            window.location.hash = "successlabel";
        }
    }

    render() {

        return (
            <div className="registration">
                <div className="EditingFormTable table">
                    {
                        (this.state.successMessage) ?
                            <span id="successlabel" className="SuccessLabel">{getTranslation("sns.webparts.personal.save.done")}</span> : ""
                    }
                    <PersonalData authenticated="true" ref="activeComponent" />
                    <div className="tr text-right col-md-8 button-wrapper">
                        <input type="button" className="FormButton btn btn-primary" value={getTranslation("sns.webparts.personal.save")} onClick={this.save} />
                    </div>                      
                </div>
            </div>
        );
    }
}
                                 
export default Personal;


// WEBPACK FOOTER //
// ./src/Components/Pages/Personal.js